<template>
  <div>
    <el-form ref="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="projectId" placeholder="请选择所属项目" filterable :clearable="false">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="map-container">
      <!-- 高德地图容器 -->
      <div ref="map" class="map"></div>

      <!-- 左上角信息窗口 -->
      <div class="chart-overlay">
        <div>
          <span class="title">在岗统计</span>
          <div ref="chart" class="chart"></div>
          <div class="alarm">
            <div v-for="(item, index) in alarm" :key="index">
              <span>{{ item.name }}</span>
              <span class="value">{{ item.value || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup" v-if="showPerson" ref="popup" :class="{ gray: info.deviceStatus !== '1' }">
      <div class="header">
        <p>{{ info.workerName || (info.teamName + '【' + info.deviceNumber.substring(info.deviceNumber.length - 4,
          info.deviceNumber.length) + '】') || '--' }}</p>
        <p class="state" v-show="info.deviceStatus === '2'" :class="info.deviceStatus === '1' ? 'normal' : 'offline'">
          {{ info.deviceStatus === '1' ? '在线' : '离线' }}</p>
        <p class="state" v-show="info.deviceStatus === '1' && info.dutyStatus && ['1', '2'].includes(info.dutyStatus)"
          :class="['normal', 'alarm'][+info.dutyStatus - 1]">{{ dutyStatus[info.dutyStatus - 1] }}</p>
        <p class="state alarm" v-show="info.sosStatus && info.sosStatus === '1'">SOS</p>
      </div>
      <div class="content">
        <div class='list' v-show="info.deviceType && info.deviceType === 'D0'">
          <div v-for="(item, index) in health" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="value">{{ info[item.value] || '--' }}</p>
              <p class="state" v-if="item.value !== '--'"
                :class="(item.status === '正常' || item.status === '--') ? 'normal' : 'alarm'">{{ item.status }}</p>
            </div>
          </div>
        </div>

        <div style="display: flex; justify-content: center">
          <el-button type="primary" @click="onPlay">轨迹查看</el-button>
        </div>
      </div>
    </div>

    <playBack :showDialog.sync="showPlayBack" :worker="info" @closeDialog="closeDialog"></playBack>
  </div>
</template>

<script>
import { px2vw } from '@/utils/util'
import { getMapIcon } from '@/views/device/mapIcon'
import playBack from '@/views/person/playback.vue'
import { drawPolygon } from '@/utils/formatData'
export default {
  name: 'PersenDeviceList',
  components: {
    playBack
  },
  data() {
    return {
      projectId: '',
      loading: false,
      info: {},
      map: null,
      alarm: [{
        name: 'SOS求助',
        value: 0
      }],
      marker: [],
      showPlayBack: false,
      showPerson: false,
      health: [
        {
          name: '收缩压(mmHg)',
          value: 'highpressure',
          icon: 'icon-xieya',
          status: ''
        },
        {
          name: '舒张压(mmHg)',
          value: 'lowpressure',
          icon: 'icon-xieya',
          status: ''
        },
        {
          name: '心率(次/min)',
          value: 'rate',
          icon: 'icon-xinshuai',
          status: ''
        }
      ],
      dutyStatus: ['在岗', '脱岗', '--'],
      objectId: '',
      centerPossion: [],
      ploygons: [],
      locationList: [],
      ondutyList: [],
      markers: [],
      infoWindow: null,
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  filters: {
    imgListFormat(list) {
      return list || []
    }
  },
  watch: {
    projectId(val) {
      if (val) {
        // 销毁旧地图实例
        if (this.map) {
          this.map.destroy()
          this.map = null
        }
        this._chart && this._chart.dispose()
      }
      this.initMap()
    }
  },
  created() {
    this.projectId = this.projectList[0].projectId
    this.initMap()
  },
  beforeDestroy() {
    if (this.map) {
      this.map.off('click', this.handleMapClick)
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    // 初始化地图
    async initMap() {
      if (!this.projectId) return;
      if (this.projectId) {
        const project = this.projectList.find(item => item.projectId === this.projectId)
        if (project.projectId) {
          this.centerPossion = [project.longitude, project.latitude]
        } else {
          this.$message.error('暂无此项目，请选择其他项目')
          return
        }
      }
      await this.getLocationList()
      await this.loadData()
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
      this.$nextTick(() => {
        this.map = new AMap.Map(this.$refs.map, {
          zoom: 12,
          center: this.centerPossion || [118.754717, 32.046607]
        })
        if (this.locationList.length) {
          this.ploygons = drawPolygon(this.map, this.locationList, {
            bubble: true,
            fillColor: 'rgb(54, 203, 203)', // 背景色
            fillOpacity: 0.3, // 背景透明
            strokeWeight: 4, // 线条宽度
            strokeColor: 'rgba(54, 203, 203, 1)', // 线条色
            clickable: true // 是否可点击
          })
        }
        if (this.ondutyList.total) {
          this.drawMarker(this.ondutyList.list)
        }
        this.map.on('click', this.handleMapClick)
      })
    },

    // 获取项目locationList
    getLocationList() {
      return this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then(res => {
        this.locationList = res.locationList || []
      })
    },
    // 获取工人在岗率
    loadData() {
      if (!this.projectId) return Promise.resolve()
      return this.$axios.get(this.$apis.worker.selectWorkerSum, {
        projectId: this.projectId
      }).then(res => {
        this.ondutyList = res.deviceList || []
        this.refreshEchart(res.deviceCount)
      })
    },
    // 重新绘制
    refreshEchart(res) {
      this._chart && this._chart.clear()
      this.$nextTick(() => {
        this.renderPie(res)
      })
      this.alarm[0].value = res.sosCount
    },
    renderPie(res) {
      const color = ['#89F3F7', '#E51212', '#FEE186']
      const title = {
        name: '在岗率',
        per: res.onDevicePer || 0
      }
      const data = [{
        name: '在岗',
        value: res.onWorkCount || 0
      },
      {
        name: '脱岗',
        value: res.offWorkCount || 0
      }]
      setTimeout(() => {
        this.renderChart(data, color, title)
      }, 500)
    },
    renderChart(data, color, title) {
      this._chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          show: false,
          formatter: '{a} <br/>{b}: {d}%',
          textStyle: {
            fontSize: px2vw(12)
          }
        },
        title: {
          show: title.name,
          text: title.per + '%',
          subtext: title.name,
          left: '28%',
          textAlign: 'center',
          top: '30%',
          textStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            fontFamily: 'PingFangSC, PingFang SC'
          },
          subtextStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            lineHeight: 0,
            fontFamily: 'PingFangSC, PingFang SC'
          }
        },
        legend: {
          orient: 'vertical',
          top: 'center',
          left: '60%',
          icon: 'circle',
          itemWidth: px2vw(6),
          formatter: (name) => {
            const index = data.findIndex((item) => item.name === name)
            const arr = '{a|' + name + '}{b|' + data[index].value + '}'
            return arr
          },
          textStyle: {
            fontSize: px2vw(14),
            color: '#000000',
            align: 'center',
            rich: {
              a: {
                padding: [0, 0, 0, px2vw(2)]
              },
              b: {
                padding: [px2vw(15), 0, px2vw(15), px2vw(28)]
              }
            }
          }
        },
        color: color,
        series: [
          {
            // avoidLabelOverlap: false,
            hoverOffset: 0,
            type: 'pie',
            radius: ['90%', '100%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            zlevel: 4,
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 1)',
                borderWidth: 0,
                color: (value) => {
                  return color[value.dataIndex]
                }
                // shadowColor: 'rgba(0,0,0,0.4)',
                // shadowBlur: 10
              }
            },
            data: data,
            labelLine: {
              show: false
            }
          },
          {
            labelLine: {
              show: false
            },
            itemStyle: {
              opacity: 0.2,
              borderColor: '#ffffff',
              borderWidth: 2
            },
            type: 'pie',
            hoverAnimation: false,
            radius: ['70%', '90%'],
            center: ['30%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: data,
            zlevel: -1
          }
        ]
      }
      this._chart.clear()
      this._chart.setOption(option)
    },

    // 地图上的人员
    drawMarker(list) {
      this.markers = []
      let markerName = ''
      if (list && list.length) {
        // 循坏将设备marker添加到地图
        list.forEach((item) => {
          if (item.longitude && item.latitude) {
            const icon = this.getIcon(item)
            if (item.teamName) {
              markerName = item.teamName + '【' + item.deviceNumber.substring(item.deviceNumber.length - 4, item.deviceNumber.length) + '】'
            } else {
              markerName = item.workerName || '--'
            }
            const marker = new AMap.Marker({
              icon: new AMap.Icon({
                // 图标的取图地址
                image: icon
              }),
              offset: new AMap.Pixel(-18, -48),
              position: new AMap.LngLat(Number(item.longitude), Number(item.latitude)),
              extData: { ...item, type: 'icon' },
              label: {
                direction: 'top',
                content: "<div class='labelContent'>" + markerName + "</div>",
                offset: new AMap.Pixel(0, -5),
              }
            })
            marker.detail = item
            marker.on('click', () => {
              this.info = marker.detail
              this.showInfoWindow(marker)
            })
            this.map && this.map.add(marker)
            this.markers.push(marker)
          }
        })
      }
    },
    // 获取图片
    getIcon(data) {
      if (data.type) {
        return require('@/assets/img/mapIcon/device_1006_1.svg')
      } else {
        return getMapIcon('1006', data)
      }
    },
    // 展示信息窗体
    showInfoWindow(marker) {
      if (this.infoWindow) {
        this.infoWindow.close()
      }
      this.showPerson = true
      this.$nextTick(() => {
        this.infoWindow = new AMap.InfoWindow({
          isCustom: true,
          content: (this.$refs.popup), // 使用自定义的InfoWindow内容
          offset: new AMap.Pixel(0, -45)
        })
        this.infoWindow.open(this.map, marker.getPosition())
      })
    },
    // 地图点击处理关闭信息窗体
    handleMapClick() {
      if (this.infoWindow) {
        this.infoWindow.close()
        this.infoWindow = null
      }
      this.showPerson = false
    },
    onPlay() {
      this.showPlayBack = true
    },
    closeDialog() {
      this.showPlayBack = false
    }
  }
}
</script>

<style scoped lang="scss">
.map-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 160px);
  // max-height: 754px;


  .map {
    width: 100%;
    height: 100%;
  }

  .chart-overlay {
    position: absolute;
    top: 50px;
    left: 40px;
    z-index: 909;
    width: 250px;
    min-height: 173px;
    background: var(--map-popup-bg);
    color: var(--header-bar-title-color);
    box-shadow: 0px 5px 16px 0px rgba(186, 186, 186, 0.96);
    border-radius: 10px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;

    >div {
      &:last-of-type {
        border-bottom: 0;
      }

      >div {
        padding: 20px 20px 20px 20px;

        &.chart {
          height: 77px;
          box-sizing: content-box;
        }

        &.alarm {
          display: flex;
          padding: 5px;

          >div {
            flex: 1;

            .dot {
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-right: 6px;
            }

            .value {
              display: inline-block;
            }
          }

          span {
            font-family: OPPOSans, OPPOSans;
            font-weight: normal;
            font-size: 12px;
            color: var(--header-bar-title-color);
            line-height: 16px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }

    .title {
      display: inline-block;
      width: 100%;
      height: 33px;
      line-height: 33px;
      padding-left: 19px;
      border-bottom: 1px solid var(--right-bg-tab);
    }

    .alarm {
      display: flex;
      justify-content: space-around;
      width: 100%;
      border-top: 1px solid #EAEAEA;

      >div {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        padding: 15px;

        .value {
          color: #E51212;
        }
      }
    }
  }
}

.marLeft {
  margin-left: 0px;
}

.iconfont {
  font-size: 12px;
  margin-right: 8px;
}

::v-deep .amap-marker-label {
  border: none;

}

.popup {
  &.gray {
    .icon {
      background: #B7B7B7 !important;
      border: 2px solid #B7B7B7 !important;
    }

    .setting {
      color: #B7B7B7 !important;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    border-radius: 10px 10px 0px 0px;
    padding: 10px 19px;
    color: #FFFFFF;
    font-size: 14px;
    font-family: PingFang SC;

    p:nth-of-type(1) {
      width: 260px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .state {
    margin-left: 2px;
    white-space: nowrap;

    // color: #03FF21;
    &.offline {
      color: #E6E6E6;
      //
    }

    &.alarm {
      //
      color: #E51212;
    }

    &.normal {
      //
      color: #03FF21;
    }
  }

  .content {
    color: var(--header-bar-title-color);
    background: var(--right-bg-color);
    // margin: 20px 0 -8px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 12px;
    border-radius: 0px 0px 10px 10px;

    .video {
      width: 360px;
      height: 180px;
      border-radius: 4px;
      margin-top: -16px;
    }

    .item {
      position: relative;
      padding-left: 13px;
      margin-bottom: 19px;

      .setting {
        position: absolute;
        right: 0;
        top: 3px;
        cursor: pointer;
        color: #42A5F5;
      }

      &::after {
        position: absolute;
        content: '';
        left: 0px;
        top: calc(50% - 2px);
        width: 4px;
        height: 4px;
        background: var(--header-bar-title-color);
        border-radius: 2px;
      }
    }

    .list {
      // display: flex;
      // flex-wrap: wrap;
      display: grid;
      grid-template-columns: 126px 129px 100px;

      &.padding20 {
        margin-top: 21px;
      }

      >div {
        display: flex;
        flex: 0 0 calc((100%)/3);
        font-size: 12px;
        margin-bottom: 28px;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          width: 30px;
          height: 30px;
          background: #42A5F5;
          border-radius: 50%;
          border: 2px solid #D8EEFF;
          margin-right: 9px;

          i {
            color: #ffffff;
          }
        }

        .status {
          &.alarm {
            color: #FF3F29;
          }

          &.normal {
            color: #52C41A;
          }
        }

        &:last-child,
        &:nth-of-type(12),
        &:nth-of-type(11) {
          .name {
            white-space: nowrap;
          }
        }

        &:nth-of-type(12) {
          grid-column: 1 / 2;
        }
      }
    }
  }

  .time {
    height: 30px;
    line-height: 30px;
    background: #EAEEF5;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    font-size: 12px;
  }

  .tabs {
    display: flex;
    width: 360px;
    height: 27px;
    background: #3277F3;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    overflow: hidden;
    padding-left: 6px;
    padding-top: 2px;

    >div {
      display: flex;
      justify-content: center;
      align-content: center;
      width: 66px;
      cursor: pointer;
      line-height: 24px;

      &.active {
        width: 66px;
        // height: 26px;
        // background: #F5F5F5;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        border-bottom: 66px solid #F5F5F5;
        border-right: 10px solid transparent;
      }
    }
  }

  ::v-deep {
    .el-date-editor {
      width: 294px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #C3C3C3;
      margin: 20px 33px;
    }

    .el-table th.gutter {
      display: none;
      width: 0
    }

    .el-table colgroup col[name='gutter'] {
      display: none;
      width: 0;
    }
  }
}
</style>
